import React from 'react'

import {
  ADDTOMAIN,
  CARRELLO,
  GETPRODOTTOVALUES,
  PRODOTTI,
  PROSSIMIARRIVI,
  WISHLISTELEMENTS,
  MOVETOLATER,
  PAGINEDETAIL,
  RIGHECARRELLO,
  RICHIEDIDISPONIBILITA,
  GIORNICONSEGNA,
  ORDINASUBITO,
} from '../../utils/endpoint'
import { Breadcrumbs, MetaSeo } from '../../components/index'
import { useEffect, useState, useContext } from 'react'
import { displayNotification } from '../../components/atoms/Notifica/Notifica'
import { HandleWishlist } from '../../utils/HelperNewProdottoCard/utils'
import ProdottoTemplate from '../../components/template/ProdottoTemplate/ProdottoTemplate'
import { api } from '../../utils'
import { QuantitaContext } from '../../context/QuantitaContext'
import { useSelector } from 'react-redux'
import SkeletonLoadingProduct from '../../components/atoms/SkeletonLoading/SkeletonLoadingProduct'
import { CartContext } from '../../context/CartContext'
import Button from '../../components/atoms/Button/Button'
import NewModal from '../../components/molecules/NewModal/NewModal'
import ModalBlocks from '../../components/molecules/ModalBlocks/ModalBlocks'
import useTrans from '../../hooks/useTrans'
import { useRouter } from 'next/router'
import { createToken } from '../cart/checkout/[token]'
import * as Sentry from '@sentry/browser'
import Correlati from '../../components/organisms/Correlati/Correlati'

const SchedaProdotto = ({ data, slug, prodotto_articolo, page, statusCode }) => {
  if (!page) return <Error statusCode={statusCode} />
  const { utente } = useSelector((state) => state.utente)
  const [prodotto, setProdotto] = useState(data)
  const [Loading, setLoading] = useState()
  const [changingPreventivo, setChangingPreventivo] = useState(false)
  const [firstFetch, setFirstFetch] = useState(true)
  const { quantita, resetAllQuantita, getQuantita } = useContext(QuantitaContext)
  const { refreshCart, setCartMain } = useContext(CartContext)
  const [reload, setReload] = useState(false)

  const [selectedArticolo, setSelectedArticolo] = useState(
    slug ? prodotto_articolo : prodotto.articoli[0]
  )
  const [selectedTaglia, setTaglia] = useState(
    selectedArticolo
      ? selectedArticolo.attributi_lista.filter((item) => item.attributo == 8)[0]
      : ''
  )
  const [selectedColor, setColor] = useState(
    selectedArticolo
      ? selectedArticolo.attributi_lista.filter((item) => item.attributo == 7)[0]
      : data.colori[0]
  )
  const [carrello, setCarrello] = useState(null)
  const { initilizeCell, initializeAll, setContextCart } = useContext(QuantitaContext)
  const { service_gift } = useSelector((state) => state.servicegift)
  const [consegna, setConsegna] = useState()
  const [prodottoWishlist, setProdottoWishlist] = useState(false)
  const [open, setOpen] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  const [personalizzazionePrenotazione, setPersonalizzazionePrenotazione] = useState(null)
  const t = useTrans()
  const router = useRouter()

  const OrdinaSubito = async () => {
    try {
      const response = await api.post(`${CARRELLO}${carrello?.id}/${ORDINASUBITO}`, {
        lang: router.locale,
      })
      const { id } = await response.data

      // controllo che i loghi siano stati caricati
      let loghiMancanti = false
      if (carrello.personalizzazioni_carrello) {
        carrello.personalizzazioni_carrello.forEach((personalizzazione) => {
          if (personalizzazione.posizioni) {
            if (
              !personalizzazione.posizioni[0].logo_file ||
              (!personalizzazione.stesso_logo && !personalizzazione.posizioni[1].logo_file)
            ) {
              loghiMancanti = true
            }
          }
        })
      }
      if (loghiMancanti) {
        router.push('/cart')
      } else {
        router.push(`/cart/checkout/${createToken(id)}`)
      }
    } catch (err) {
      displayNotification('error.ordinaSubito', err.message, 'error')
    }
  }

  const AddToCartMain = React.useCallback(async (ordina_subito = false) => {
    if (carrello && carrello.id) {
      setChangingPreventivo(true)
      api
        .post(`${CARRELLO}${carrello.id}/${ADDTOMAIN}`, {
          salvato_per_dopo: false,
          lang: router.locale,
        })
        .then((response) => {
          // ! Prima veniva messo setCarrello -> Ma questa Post riceve il Carrello Main non quello Preventivo
          setCarrello(null)
          refreshCart()
          displayNotification(
            'add_to_main',
            t('Hai aggiunto gli articoli nel Carrello'),
            'success',
            () => router.push('/cart/'),
            t('Vai al Carrello')
          )
          setChangingPreventivo(false)
        })
        .catch((err) => {
          setChangingPreventivo(false)
          displayNotification('error', err.message, 'error')
        })
    }
  })

  const SaveForLater = async () => {
    if (!carrello) {
      return
    }
    api
      .post(`${CARRELLO}${carrello.id}/${MOVETOLATER}`, {
        salvato_per_dopo: true,
        lang: router.locale,
      })
      .then((response) => {
        displayNotification(
          'success.saveForLater',
          t('Hai salvato per dopo questi articoli'),
          'success',
          () => router.push('/cart/'),
          t('Vai al Carrello')
        )
        setCarrello(null)
      })
      .catch((err) => displayNotification('error.saveFprLater', err.message, 'error'))
  }

  const CreateModalContent = (articoli) => {
    return <ModalBlocks.ProssimiArrivi articoli={articoli} />
  }

  const deleteRigaCarrello = async (id) => {
    await api
      .delete(`${RIGHECARRELLO}${id}/`)
      .then((response) =>
        api.get(CARRELLO + carrello.id + '/', { params: { lang: router.locale } })
      )
      .then((res) => {
        setCarrello(res.data)
        displayNotification('success.delete.riga', t("Hai eliminato con successo l'articolo"))
      })
      .catch((err) => displayNotification('error.delete.riga', err.message, 'error'))
      .catch((err) => displayNotification('error.delete.riga', err.message, 'error'))
  }

  const CheckPrenotazione = (articoli) => {
    return articoli.filter((item) => item.prenotazione == true && item.quantita > 0)
  }

  const CarrelloPost = (articoli, pers = null, isEdit, reload = false) => {
    let elements = articoli.filter((item) => item.quantita > 0)
    let carrelloId = carrello?.id ? `${carrello.id}/` : ''
    setChangingPreventivo(true)
    if (elements.length == 0) {
      return
    }

    const righe = articoli
      .filter((item) => item.quantita > 0)
      .map((item) => {
        return {
          salvato_per_dopo: false,
          personalizzazione_carrello_id: pers,
          prossimi_arrivi_ids: item.prenotazione
            ? item.prossimi_arrivi
              ? item.prossimi_arrivi.map((value) => value.id)
              : []
            : [],
          articolo_id: item.id,
          quantita: getQuantita(item?.codice),
        }
      })
    // ! Righe contiene la Quantità Giusta
    carrello
      ? api
          .put(CARRELLO + carrelloId, {
            tipologia: 'PREVENTIVO',
            righe_carrello: righe,
            lang: router.locale,
          })
          .then((response) => {
            setChangingPreventivo(false)
            setCarrello(response.data)
            displayNotification(
              response.data.id,
              isEdit
                ? t('Hai modificato la quantità con successo')
                : t('Hai aggiunto con Successo gli articoli')
            )
          })
          .catch((err) => {
            setChangingPreventivo(false)
            displayNotification('error', err.message, 'error')
          })
      : api
          .post(CARRELLO, {
            tipologia: 'PREVENTIVO',
            lang: router.locale,
            righe_carrello: articoli
              .filter((item) => item.quantita > 0)
              .map((item) => {
                return {
                  salvato_per_dopo: false,
                  personalizzazione_carrello_id: pers,
                  prossimi_arrivi_ids: item.prenotazione
                    ? item.prossimi_arrivi
                      ? item.prossimi_arrivi.map((value) => value.id)
                      : []
                    : [],
                  articolo_id: item.id,
                  quantita: item.quantita,
                }
              }),
          })
          .then((response) => {
            setChangingPreventivo(false)
            setCarrello(response.data)
            displayNotification(response.data.id, t('Hai aggiunto con Successo gli articoli'))
          })
          .catch((err) => {
            displayNotification('error', err.message)
            setChangingPreventivo(false)
          })
  }

  const resetData = async () => {
    resetAllQuantita()
    await Setup()
  }
  //TODO gestire la prenotazione sia con carrello che senza
  const AddToCart = React.useCallback(
    async (articoli = null, pers = null, prenotazione = false) => {
      if (prenotazione) {
        CarrelloPost(articoli ? articoli : quantita, pers)
        resetData()
        return
      }
      const checked = CheckPrenotazione(articoli ? articoli : quantita)
      checked.length > 0 &&
        (setPersonalizzazionePrenotazione(pers),
        setModalContent(CreateModalContent(checked)),
        setOpen(true))
      checked.length == 0 && (CarrelloPost(articoli ? articoli : quantita, pers), resetData())
    }
  )

  const HandleColorClick = React.useCallback((colore) => {
    prodotto.articoli.filter(
      (item) => item.attributi_lista.filter((attributo) => attributo.id === colore.id).length > 0
    )[0] &&
      setSelectedArticolo(
        prodotto.articoli.filter(
          (item) =>
            item.attributi_lista.filter((attributo) => attributo.id === colore.id).length > 0
        )[0]
      )
    setColor(colore)
  })

  const ArrowClick = () => {
    HandleWishlist(prodottoWishlist, prodotto).then((response) => {
      setProdottoWishlist(response)
      displayNotification(
        response,
        t(`Hai ${response ? 'Aggiunto' : 'Rimosso'} dagli elementi salvati il prodotto`)
      )
    })
  }

  const GetWishlist = async (dataFetched) => {
    const params = {
      elements: dataFetched.id,
      lang: router.locale,
    }
    if (!utente) {
      return dataFetched
    }
    const response = await api
      .get(WISHLISTELEMENTS, { params })
      .then((response) => response.data[0]?.salvato && setProdottoWishlist(true))
  }

  const GetConsegna = async () => {
    utente &&
      (await api
        .get(GIORNICONSEGNA, { params: { lang: router.locale } })
        .then((response) => setConsegna(response.data)))
  }

  const Setup = async () => {
    firstFetch && setLoading(true)
    const ids = data.articoli.map((item) => item.id)
    const params = {
      articoli_ids: ids,
      lang: router.locale,
    }
    let dataFetched = data
    try {
      await api.get(GETPRODOTTOVALUES, { params }).then(
        (response) =>
          response.data &&
          response.data.forEach((element) => {
            dataFetched.articoli
              .filter((item) => item.id == element.articolo__id)
              .forEach((articolo) => {
                articolo.prezzo = element.prezzo
                articolo.disponibilita = element.disponibilita
                articolo.disponibilita_reale_maggiore = element.disponibilita_reale_maggiore
                articolo.disponibilita_in_opzione = element.disponibilita_in_opzione
                articolo.data_in_opzione = element.data_in_opzione
                articolo.con_fasce = element.con_fasce
                articolo.fasce = element.fasce
                articolo.prezzo_listino = element.prezzo_listino
              })
          })
      )
      await api
        .get(PROSSIMIARRIVI, {
          params: { lang: router.locale, articolo__prodotto_id: data.id },
        })
        .then(
          (response) =>
            response.data &&
            response.data.forEach((element) => {
              dataFetched.articoli
                .filter((item) => item.id == element.articolo_id)
                .forEach((articolo) => {
                  if (articolo.prossimi_arrivi) {
                    articolo.prossimi_arrivi.filter((check) => check.id == element.id).length ==
                      0 && articolo.prossimi_arrivi.push(element)
                  } else {
                    articolo.prossimi_arrivi = []
                    articolo.prossimi_arrivi.push(element)
                  }
                })
            })
        )

      GetWishlist(dataFetched)
      const match_article_slug = prodotto.articoli.filter((item) => item.slug == slug)[0]
      slug && setSelectedArticolo(match_article_slug ? match_article_slug : prodotto.articoli[0])
      slug &&
        setColor(selectedArticolo.attributi_lista.filter((element) => element.attributo == 7)[0])
      slug && setTaglia(selectedArticolo.attributi_lista.filter((item) => item.attributo == 8)[0])
      setProdotto(Object.assign({}, dataFetched))

      GetConsegna()
    } catch (error) {
      console.log(error)
      Sentry.captureException(error)
      setLoading(false)
    }
  }

  useEffect(async () => {
    resetAllQuantita()
    await Setup()
      .then(() => {
        firstFetch && setLoading(false)
        firstFetch && setFirstFetch(false)
      })
      .catch((err) => {
        setLoading(false)
        console.log(err)
        Sentry.captureException(err)
      })
  }, [])

  useEffect(async () => {
    if (reload && carrello && !Loading) {
      let carrelloId = carrello?.id ? `${carrello.id}/` : ''
      api
        .get(CARRELLO + carrelloId)
        .then((response) => {
          setCarrello(response.data)
        })
        .catch((err) => {})
      setReload(false)
    }
  }, [reload, carrello, Loading])

  useEffect(() => {
    GetConsegna()
  }, [utente])

  useEffect(() => {
    GetWishlist(data)
  }, [prodotto])

  useEffect(async () => {
    setContextCart(carrello)
  }, [carrello])

  useEffect(() => {
    if (selectedColor && selectedTaglia) {
      let articolo = prodotto.articoli
        .filter((item) => item.attributi_lista.find((element) => element.id === selectedColor.id))
        .find((item) => item.attributi_lista.find((element) => element.id === selectedTaglia.id))

      articolo = articolo
        ? articolo
        : prodotto.articoli.find((item) =>
            item.attributi_lista.find((element) => element.id === selectedColor.id)
          )

      setSelectedArticolo(articolo)
      setTaglia(articolo.attributi_lista.find((item) => item.attributo == 8))
    }
  }, [selectedColor, selectedTaglia])

  const OnClickRichiedi = async (id) => {
    const params = {
      lang: router.locale,
      articolo: id,
    }
    await api
      .post(`${RICHIEDIDISPONIBILITA}`, { articolo: id, lang: router.locale })
      .then(
        displayNotification(
          'richiesta_disponibilita',
          t("Verrai notificato quando l'articolo tornerà disponibile"),
          'success'
        )
      )
  }

  // PER SG NON INDICIZZO PRODOTTI
  if (service_gift) {
    page.seo.noindex = true
  }

  return (
    <>
      <MetaSeo seo={page.seo} />
      <div className="page">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />
        </div>
        {!Loading ? (
          <ProdottoTemplate
            changingPreventivo={changingPreventivo}
            deleteRigaCarrello={deleteRigaCarrello}
            setSelectedTaglia={setTaglia}
            setSelectedColor={setColor}
            service_gift={service_gift}
            utente={utente}
            indirizzo="prova"
            consegna={consegna}
            prodotto={prodotto}
            selectedArticolo={selectedArticolo}
            selectedTaglia={selectedTaglia}
            selectedColor={selectedColor}
            HandleColorClick={HandleColorClick}
            prodottoWishlist={prodottoWishlist}
            ArrowClick={ArrowClick}
            articoli={prodotto.articoli}
            codice={prodotto.codice}
            selectedItem={selectedArticolo}
            AddToCart={AddToCart}
            AddToCartMain={AddToCartMain}
            SaveLater={SaveForLater}
            carrello={carrello}
            setCarrello={setCarrello}
            OnClickRichiedi={OnClickRichiedi}
            OrdinaSubito={OrdinaSubito}
            setReload={setReload}
          />
        ) : (
          <div className="w-container">
            <SkeletonLoadingProduct />
          </div>
        )}
        <Correlati />
        <NewModal
          visible={open}
          alert={true}
          title={'La quantità inserita non è disponibile, desideri prenotarla?'}
          text={
            <>
              <p>
                {t(
                  'La quantita inserita non è disponibile subito, ma è possibile prenotarla su più arrivi.'
                )}
                <br />
                {t(
                  "L'ordine verrà evaso dal prossimo arrivo della merce che soddisfa le quantità richieste."
                )}
              </p>
              <p>{t('Se vuoi ricevere subito gli articoli, inserisci una quantità disponibile')}</p>
            </>
          }
          className={'prenota-modal'}
          onClose={() => setOpen(false)}
          actions={[
            <Button
              label={t('Modifica quantità')}
              variant="secondary"
              size="medium"
              onClick={() => setOpen(false)}
            />,
            <Button
              label={t('Conferma prenotazione')}
              variant="primary"
              size="medium"
              onClick={() => {
                AddToCart(null, personalizzazionePrenotazione, true)
                setOpen(false)
              }}
            />,
          ]}
        >
          {modalContent}
        </NewModal>
      </div>
    </>
  )
}

export async function getServerSideProps({ res, query: { slug }, locale }) {
  try {
    const response = await api.get(`${PRODOTTI}${slug[0]}/`, { params: { lang: locale } })
    const product = await response.data

    res.setHeader('Cache-Control', 'public, max-age=43200, must-revalidate')

    const redirect = product?.redirect
    if (redirect) {
      res.setHeader('location', redirect)
      res.statusCode = 301
      res.end()
      return { props: {} }
    }

    const slug_articolo = slug.length > 1 ? slug[1] : null
    let prodotto_articolo = product.articoli.find((item) => item.slug == slug_articolo, null)

    if (!prodotto_articolo) {
      prodotto_articolo = product.articoli[0]
    }

    const pageResponse = await api
      .get(PAGINEDETAIL, {
        params: {
          chiave: 'articolo-detail',
          lang: locale,
          content_type_id: prodotto_articolo?.model,
          object_id: prodotto_articolo?.id,
        },
      })
      .catch((err) => {
        Sentry.captureException(err)
      })

    const page = pageResponse?.data ? pageResponse?.data : null

    return {
      props: {
        page,
        data: product,
        slug: slug_articolo,
        prodotto_articolo: prodotto_articolo ? prodotto_articolo : null,
      },
    }
  } catch (error) {
    res.statusCode = 404
    return { props: { statusCode: 404 } }
  }
}

export default SchedaProdotto
